<div class="flex flex-col gap-[24px]">
  <div class="flex flex-row justify-between items-center">
    <div class="flex flex-row gap-[24px] lt-md:gap-[16px] justify-start items-center">
      <mat-icon>menu</mat-icon>
      <h3 class="app-ellipsis">
        {{ heatingCircuitName }}
      </h3>
    </div>

    <div class="flex flex-row justify-end items-center">
      <button
        [disabled]="!isAddCommandExecutable || !enabled"
        gtm="onAddOtherRoom"
        mat-stroked-button
        color="primary"
        (click)="addOtherRoom()"
      >
        {{ '+INSTALLATIONS.SRC.OTHER_ROOM.ADD_OTHER_ROOM_BUTTON' | translate }}
      </button>
      <div
        class="tooltip-wrapper flex flex-row justify-start items-start"
        *ngIf="!isAddCommandExecutable || !enabled"
      >
        <mat-icon
          *ngIf="!enabled; else addCommandNotExecutableTooltip"
          class="warning-icon"
          matTooltip="{{ '+COMMISSIONING.OVERVIEW.TOOLTIP.OTHER_ROOMS_DISABLED' | translate }}"
        >
          error_outline
        </mat-icon>
        <ng-template #addCommandNotExecutableTooltip>
          <mat-icon
            class="warning-icon"
            matTooltip="{{ '+COMMISSIONING.OVERVIEW.TOOLTIP.ADD_ROOM_NOT_POSSIBLE' | translate }}"
          >
            error_outline
          </mat-icon>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="offset flex flex-col gap-[24px] lt-md:gap-[8px]">
    <app-feature-details-grid *ngIf="heatingCircuit as hc" class="feature-details-grid">
      <app-feature-list-container>
        <app-feature-list-item
          data-at-circuit-name
          [label]="'+COMMISSIONING.DEVICE_PANEL.HEATING_CIRCUIT.LABEL' | translate"
          [value]="installationService.getCircuitName(hc) | async"
        >
        </app-feature-list-item>
      </app-feature-list-container>
    </app-feature-details-grid>
  </div>
</div>
